<template>
  <div class="home">
    <div class="nav-header">
      <div class="container">
        <div class="nav">
          <router-link to="/">
            <div class="logo">
              <img src="@/assets/512_new.png" alt="" />
              <div class="title">
                <h1>驾考雷达</h1>
                <i class="iconfont icon-sousuo1x"></i>
              </div>
            </div>
          </router-link>
          <a href="#/" class="nav-item" @click="toggleActive('home')">
            <span :class="{ actived: activeClass == 'home' }">首页</span>
            <span class="sanjiao" v-if="activeClass == 'home'"></span>
          </a>
          <a href="#intro" class="nav-item" @click="toggleActive('intro')">
            <!-- <span :class="{ actived: activeClass == 'intro' }">介绍</span> -->
            <span class="sanjiao" v-if="activeClass == 'intro'"></span>
          </a>
        </div>
      </div>
    </div>
    <!-- <div style="height: 70px"></div> -->
    <div class="home-banner" id="top">
      <img src="@/assets/home_new.jpeg" alt="" class="home_back" />
      <div class="container">
        <div class="content">
          <div class="right">
            <div class="header">
              驾考雷达
              <!-- <span class="downloadApp" @click="downloadApp">立即下载</span> -->
            </div>
            <div class="hint">
              驾考雷达实时同步更新2026年驾考科目一、科目四考试题库，通过历年大数据深度分析，精选全国优质驾校供学员学车选择，用科学有效的方法助力学员高效备考驾照资格考试！
              <br/>
              <br/>
              完整学车流程，为学员提供从报名到领驾照的一站式驾考服务，深受驾校、教练、司机、学员喜爱的驾驶员模拟考试练习软件!
            </div>
          </div>
          <div class="phone">
            <!-- <img src="@/assets/2.jpg" alt="" /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="container" id="intro">
      <div class="img1">
        <div class="left">
          <div class="left-title">题库新</div>
          <div class="line"></div>
          <p>根据新的驾考考试大纲，各地区题库实时更新</p>
        </div>
        <div class="phone1">
          <img src="@/assets/image1_new.jpg" alt="" />
        </div>
      </div>
      <div class="img2">
        <div class="phone2">
          <img src="@/assets/image2_new.png" alt="" />
        </div>
        <div class="right">
          <div class="right-title">考点练习</div>
          <div class="line"></div>
          <p style="width: 650px">
            专项练习定点练习，知识点逐个击破，考点全掌握
          </p>
        </div>
      </div>
      <div class="img4">
        <div class="left">
          <div class="left-title">真实考场模拟</div>
          <div class="line"></div>
          <p>
            按照当前科目考试大纲要求，仿真模拟考试，提前模拟考场环境，攻克考试重难点
          </p>
        </div>
        <div class="image3">
          <img src="@/assets/image3_new.png" alt="" />
        </div>
      </div>
      <!--  <div class="img2">
        <div class="phone2">
          <img src="@/assets/6.jpg" alt="" />
        </div>
        <div class="right">
          <div class="right-title">网络摄像头检测</div>
          <div class="line"></div>
          <p>
          深度检测，防止酒店，公寓，出租房，公共场所等被偷拍，提供隐私保护与安心防护【短信拦截】
          </p>
        </div>
      </div>
       <div class="img1">
         <div class="left">
          <div class="left-title">短信拦截</div>
          <div class="line"></div>
          <p style="width: 650px">能识别垃圾短信，更有关键词、号码等自定义设置，杜绝漏网之鱼，还你清净生活</p>
        </div>
        <div class="phone1">
          <img src="@/assets/7.jpg" alt="" />
        </div>

      </div>
       <div class="img2">
        <div class="phone2">
          <img src="@/assets/8.jpg" alt="" />
        </div>
        <div class="right">
          <div class="right-title">电池养护</div>
          <div class="line"></div>
          <p>
         实时监控手机电量，预估电池可用时间，多种酷炫充电动画供你选择
          </p>
        </div>
      </div>-->
    </div>
    <div class="home_icon">
      <img src="@/assets/512_new.png" alt="" />
      <h4 style="font-weight: blod; font-size: 40px; margin-top: 20px">
        驾考雷达
      </h4>
    </div>
    <div class="message">
      <div class="item">
        <h3>公司名称</h3>
        <p>四平全能通科技有限公司</p>
      </div>
      <div class="item">
        <h3>公司地址</h3>
        <p>四平市伊通满族自治县营城子镇十街坊0201号54幢一层</p>
      </div>
      <!-- <div class="item">
        <h3>商务合作</h3>
        <p></p>
      </div> -->
<!--      <div class="item">
        <h3>客服QQ</h3>
        <p>2118789460</p>
      </div>
      <div class="item">
        <h3>电话</h3>
        <p>17600585466</p>
      </div>-->
    </div>

    <div class="banquan">
<!--      <div class="linkList">
        <div class="item">
          <div class="privacy" @click="goDownLoad">点击下载</div>
        </div>
        <div class="item">
          <div class="privacy" @click="goPrivacy">隐私政策</div>
        </div>
        <div class="item">
          <div class="privacy" @click="goAnQuan">安全中心</div>
        </div>
        <div class="item">
          <div class="privacy" @click="goHelp">帮助中心</div>
        </div>
      </div>-->
      <span style="cursor: pointer" class="banquan_content" @click="jumpOther"
        >© 四平全能通科技有限公司 | 吉ICP备2026007413号-1A</span
      >
    </div>
    <!--<div class="" id="join">
      <div class="message">
        <div class="item">
          <h3>客服邮箱</h3>
          <p>sbgrceone@outlook.com</p>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
  export default {
    name: "home",
    components: {},
    data() {
      return {
        activeClass: "home",
      };
    },
    methods: {
      toggleActive(name) {
        this.activeClass = name;
      },
      // 跳转到隐私政策
      goDownLoad() {
        window.open(
          `https://apps.apple.com/cn/app/%E9%A9%BE%E7%85%A7%E8%80%83%E8%AF%95%E5%85%A8%E8%83%BD%E9%80%9A/id6757356623`
        );
      },
      // 跳转到隐私政策
      goPrivacy() {
        window.open(
          `https://timeyear.psaso.net/jiakaodiandiantong/h5/#/PrivacyPolicy?appName=驾考雷达`
        );
      },
      // 跳转到安全中心
      goAnQuan() {
        window.open(
          `https://timeyear.psaso.net/jiakaodiandiantong/h5/#/securityCenter?appName=驾考雷达`
        );
      },
      goHelp() {
        window.open(
          `https://timeyear.psaso.net/jiakaodiandiantong/h5/#/help?appName=驾考雷达`
        );
      },
      // 下载app
      downloadApp() {
        // location.href = "https://mallcdngn.oss-cn-beijing.aliyuncs.com/apk/greenleopard_1.0.0_release_06.09_kuai.apk";
        location.href = "https://mallcdn.playapper.top/apk/release/lbsjws.apk";
      },
      jumpOther() {
        window.open("https://beian.miit.gov.cn/#/Integrated/index");
      },
    },
    mounted() {
      let _this = this;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  };
</script>
<style scoped lang="less">
  .home {
    .banquan {
      width: 100%;
      min-width: 1200px;
      height: 80px;
      color: #fff;
      line-height: 80px;
      // font-size: 24px;
      background: rgba(37, 42, 52, 1);
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      &_content {
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .container {
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .logo-box {
        width: 100%;
        padding-top: 107px;
        .logo {
          width: 153px;
          height: 153px;
          background: url("../assets/512.png") no-repeat;
          background-size: 100%;
          margin: 0 auto;
        }
        h2 {
          font-size: 36px;
          margin-top: 30px;
          color: #333;
        }
        p {
          font-size: 20px;
          color: #999;
          margin-top: 10px;
        }
      }
      .img1 {
        width: 1200px;
        height: 900px;
        // margin-top: 140px;
        display: flex;
        align-items: center;
        .left {
          margin-right: 152px;
          display: flex;
          flex-direction: column;
          .left-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 86px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
            width: 628px;
          }
        }
        .phone1 {
          // height: 100%;
          width: 394px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .line {
        width: 120px;
        height: 6px;
        background: #f3c33d;
        border-radius: 3px;
        margin-top: 26px;
      }
      .img4 {
        width: 1200px;
        height: 900px;
        // margin-top: 140px;
        display: flex;
        align-items: center;
        .left {
          margin-right: 12px;
          display: flex;
          flex-direction: column;
          .left-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 86px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
            width: 628px;
          }
        }
        .phone1 {
          // height: 100%;
          width: 394px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .image3 {
          width: 560px;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
      .img2 {
        width: 1200px;
        height: 800px;
        // margin-top: 65px;
        display: flex;
        align-items: center;
        .phone2 {
          // height: 100%;
          width: 394px;

          margin-right: 146px;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          .right-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 162px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
          }
        }
      }
      .img3 {
        width: 100%;
        height: 702px;
        margin-top: 138px;
        /*background: url("../assets/img3.png") no-repeat;
                                                                                                                    background-size: 100%;*/
        display: flex;
        /*justify-content: space-between;*/
        .left {
          margin-right: 152px;
          display: flex;
          flex-direction: column;
          .left-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 86px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
            width: 628px;
          }
        }
      }
    }
    .home-banner {
      width: 100%;
      min-width: 1200px;
      height: 900px;
      margin-top: 70px;
      position: relative;
      .home_back {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
      }
      .container {
        position: relative;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .content {
          display: flex;
          align-items: center;
          .phone {
            width: 394px;
            // height: 880px;

            margin-right: 150px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .right {
            color: #fff;
            text-align: left;
            .header {
              font-weight: 600;
              font-size: 80px;
              //line-height: 38px;
            }
            .hint {
              width: 700px;
              font-size: 30px;
              line-height: 45px;
              margin-top: 29px;
            }
            .btn {
              width: 330px;
              height: 100px;
              border: 3px solid #fff;
              font-size: 40px;
              font-weight: 500;
              line-height: 94px;
              text-align: center;
              border-radius: 50px;
              margin-top: 56px;
              color: #fff;
              padding: 0;
              &:hover {
                color: #fff;
              }
            }
          }
        }
      }
    }
    .nav-header {
      height: 70px;
      width: 100%;
      position: fixed;
      top: 0;
      display: flex;
      justify-content: center;
      background: #fff;
      color: #333333;
      z-index: 9;
      .container {
        width: 1200px;
      }
      .nav {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        .logo {
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 7px;
          }
          .title {
            h1 {
              display: inline-block;
              color: #000;
              font-weight: bold;
              font-size: 26px;
              margin-right: 13px;
            }
            span {
              display: inline-block;
              color: #999999;
              font-size: 18px;
            }
          }
        }
        .nav-item {
          cursor: pointer;
          text-align: center;
          height: 70px;
          line-height: 70px;
          font-size: 18px;
          display: flex;
          align-items: center;
          position: relative;
          padding: 0 30px;
          color: #333;
          -webkit-touch-callout: none; /* iOS Safari */
          -webkit-user-select: none; /* Chrome/Safari/Opera */
          -khtml-user-select: none; /* Konqueror */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently not supported by any browser */
          text-decoration: none;
          &:hover {
            // color: #f3c33d;
          }
          span {
            cursor: pointer;
            padding-top: 5px;
            &.actived {
              // color: #f3c33d;
            }
          }
          .sanjiao {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 11px;
            width: 29px;
            // background: url("../assets/img1.png") no-repeat;
            background-size: 100%;
          }
        }
      }
    }
    .home_icon {
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 194px;
        height: 194px;
        margin-top: 105px;
      }
    }
    .message {
      margin-top: 114px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(37, 42, 52, 1);
      height: 140px;
      .item {
        text-align: center;
        margin-right: 100px;
        .privacy {
          color: #ffffff;
          font-size: 20px;
          text-decoration: underline;
          cursor: pointer;
        }
        // &:last-child {
        //   margin-right: 0;
        // }
        h3 {
          font-size: 24px;
          color: #fff;
          font-weight: 500;
        }
        p {
          font-size: 18px;
          color: #fff;
          margin-top: 17px;
        }
      }
    }
  }
  .linkList {
    background: rgba(37, 42, 52, 1);
    display: flex;
    justify-content: center;
    align-items: center;

    .item {
      text-align: center;
      margin-right: 15px;
      .privacy {
        color: #ffffff;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .downloadApp {
    font-size: 25px;
    padding: 5px 10px;
    border-radius: 5px;
    color: #fff;
    background: #02cf68;
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue